import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { AchievementsSection } from '../components/sections/AchievementsSection';
import { OfferStackSection } from '../components/sections/OfferStackSection';
import { IdentitySection } from '../components/sections/IdentitySection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../QA Section';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
import { FooterSection } from '../FOOTER LEGAL';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0a1628] overflow-x-hidden" data-id="element-241">
      <HeroSection data-id="element-242" />
      <ProblemSection data-id="element-243" />
      <AchievementsSection data-id="element-244" />
      <OfferStackSection data-id="element-245" />
      <IdentitySection data-id="element-246" />
      <TestimonialsSection data-id="element-247" />
      <GuaranteeSection data-id="element-248" />
      <FAQSection data-id="element-249" />
      <FinalCtaSection data-id="element-250" />
      <FooterSection data-id="element-251" />
    </main>;
}